import React from 'react';
import I18n from 'i18n-js';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { Paths } from './shared/url_helpers';
import { RCNotice } from '@reverbdotcom/cadence/components';


interface IProps {
  onOpenSettings: () => void;
  onSubmit: () => void;
  onReject: () => void;
  requireExplicitPrivacyConsent: boolean;
}

export default function UserPrivacyConsentPopup({
  onOpenSettings,
  onSubmit,
  onReject,
  requireExplicitPrivacyConsent,
}: IProps) {
  function getActions() {
    const primaryAction = {
      primary: {
        buttonText: I18n.t('discovery.userPrivacyConsentModal.accept'),
        onClick: onSubmit,
        initialFocus: true,
      },
    };

    if (!requireExplicitPrivacyConsent) {
      return primaryAction;
    }

    return {
      ...primaryAction,
      secondary: {
        buttonText: I18n.t('discovery.userPrivacyConsentModal.reject'),
        onClick: onReject,
        closeOnClick: false,
        variant: 'filled' as const,
      },
    };
  }

  return (
    <>
      <RCNotice
        isOpen
        title={I18n.t('discovery.userPrivacyConsentModal.title')}
        actions={getActions()}
      >
        <p className="mb-4">
          <SanitizedRender
            html={I18n.t(
              'discovery.userPrivacyConsentModal.consentBlurbText',
              {
                cookiePolicyLinkOpen: `<a href="${Paths.cookiePolicy.expand({})}" class="text-link weight-bold">`,
                linkClose: '</a>',
              },
            )}
          />
          <button type="button" onClick={onOpenSettings} className="button-as-link text-link weight-bold">
            {I18n.t('discovery.userPrivacyConsentModal.privacySettingsLink')}
          </button>
        </p>
      </RCNotice>
    </>
  );
}
